import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const ROLE_HOME = { admin: "/app/exec", executive: "/app/exec", gm: "/app/exec", hr: "/app/hr", manager: "/app/ops", staff: "/app/ops", partner: "/app/desk", secretary: "/app/desk", circle: "/app/circle" };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("dgc_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("dgc_token");
      setUser(false);
    });
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("dgc_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    localStorage.removeItem("dgc_token");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const hasRole = (user, roles) => !!user && (user.role === "admin" || roles.includes(user.role));
